/*******************************************************************************
 *** MbrJoinAply ** 회원가입
 *******************************************************************************/
import React from "react";
import Modal from "@/js/common/ui/modal/Modal";
import Button from "@/js/common/ui/Button";
import TextBox from "@/js/common/ui/input/TextBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import DialogTitleBar from "@/js/system/common/DialogTitleBar";
import Util from "@/js/common/Util";
import LabelCheckBox from "../common/ui/input/LabelCheckBox";
import ServicePolicy from "./dialog/ServicePolicy";
import PrivacyPolicy from "./dialog/PrivacyPolicy";
import AppContext from "../common/AppContext";
import Axios from "../common/Axios";
import JSEncrypt from "jsencrypt";
import { useNavigate } from "react-router-dom";

const MbrJoinAply = () => {
    const [userId, setUserId] = React.useState("");
    const [userNm, setUserNm] = React.useState("");
    const [pswd, setPswd] = React.useState("");
    const [pswd2, setPswd2] = React.useState("");
    const [upOgnzCd, setUpOgnzCd] = React.useState("");
    const [ognzCd, setOgnzCd] = React.useState("");
    const [telno, setTelno] = React.useState("");
    const [agreeTerms, setAgreeTerms] = React.useState(false);
    const [agreePrivacy, setAgreePrivacy] = React.useState(false);
    const [userIdChkOk, setUserIdChkOk] = React.useState<boolean>(false);
    const [userIdChkMsg, setUserIdChkMsg] = React.useState<string>("");
    const [passwdChkMsg, setPasswdChkMsg] = React.useState<string>("");

    const navigate = useNavigate();

    const [termsModalOpen, setTermsModalOpen] = React.useState(false);
    const [privacyModalOpen, setPrivacyModalOpen] = React.useState(false);

    const [windowWidth, setWindowWidth] = React.useState<number>(window.innerWidth);
    const [windowHeight, setWindowHeight] = React.useState<number>(window.innerHeight);

    React.useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            setWindowHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isMobile = windowWidth <= 768;

    const pageSidePadding = isMobile ? 16 : 24;
    const cardInnerPadding = isMobile ? 16 : 20;

    const cardWidth = Math.min(500, windowWidth - (pageSidePadding * 2));
    const inputWidth = Math.min(410, cardWidth - (cardInnerPadding * 2) - (isMobile ? 8 : 10));

    const modalBodyHeight = Math.min(600, windowHeight - 180);
    const modalWidth = isMobile ? Math.min(420, windowWidth - 28) : Math.min(760, windowWidth - 40);
    const modalInnerWidth = isMobile ? modalWidth - 24 : modalWidth - 40;
    const modalMaxHeight = isMobile ? Math.min(560, windowHeight - 80) : Math.min(580, windowHeight - 100);

    const fieldGap = 16;
    const labelGap = 6;
    const helperGap = 6;

    function regUserInfo() {
        if (Util.isEmpty(userId)) {
            AppContext.openAlert({
                title: "아이디 미입력",
                msg: "아이디를 입력하세요.",
                icon: "check"
            });
            return;
        }

        if (!userIdChkOk) {
            AppContext.openAlert({
                title: "아이디 사용 불가",
                msg: "사용 가능한 아이디를 변경하신 후 가입신청 하시기 바랍니다.",
                icon: "check"
            });
            return;
        }

        if (Util.isEmpty(userNm)) {
            AppContext.openAlert({
                title: "이름 미입력",
                msg: "이름을 입력하세요.",
                icon: "check"
            });
            return;
        }

        if (Util.isBlank(userNm)) {
            AppContext.openAlert({
                title: "공백 입력",
                msg: "이름에 공백이 포함되어 있으니 삭제하세요.",
                icon: "check"
            });
            return;
        }

        if (Util.isEmpty(pswd)) {
            AppContext.openAlert({
                title: "비밀번호 입력",
                msg: "비밀번호를 입력하세요.",
                icon: "check"
            });
            return;
        }

        if (!Util.chkPasswdPtn(pswd)) {
            AppContext.openAlert({
                title: "비밀번호 형식",
                msg: "비밀번호 입력형식이 맞지 않습니다.\n영문, 숫자, 특수문자를 포함한 8자 이상, 20자 이하로 입력하세요",
                icon: "check"
            });
            return;
        }

        if (Util.isEmpty(pswd2)) {
            AppContext.openAlert({
                title: "비밀번호 확인 입력",
                msg: "비밀번호 확인을 입력하세요.",
                icon: "check"
            });
            return;
        }

        if (pswd !== pswd2) {
            AppContext.openAlert({
                title: "비밀번호 불일치",
                msg: "비밀번호가 일치하지 않습니다.",
                icon: "check"
            });
            return;
        }

        if (Util.isEmpty(telno)) {
            AppContext.openAlert({
                title: "휴대폰 번호 미입력",
                msg: "휴대폰 번호를 입력하세요",
                icon: "check"
            });
            return;
        }

        if (!Util.chkPhonePtn(telno)) {
            AppContext.openAlert({
                title: "휴대폰 번호 형식",
                msg: "휴대폰 번호 형식이 맞지 않습니다.",
                icon: "check"
            });
            return;
        }

        if (Util.isEmpty(upOgnzCd)) {
            AppContext.openAlert({
                title: "1차 소속(본부) 확인",
                msg: "1차 소속(본부)를 선택하세요.",
                icon: "check"
            });
            return;
        }

        if (Util.isEmpty(ognzCd)) {
            AppContext.openAlert({
                title: "2차 소속(지부) 확인",
                msg: "2차 소속(지부)를 선택하세요.",
                icon: "check"
            });
            return;
        }

        if (!agreeTerms) {
            AppContext.openAlert({
                title: "이용약관 동의",
                msg: "이용약관에 동의하세요.",
                icon: "check"
            });
            return;
        }

        if (!agreePrivacy) {
            AppContext.openAlert({
                title: "개인정보취급방침 동의",
                msg: "개인정보취급방침에 동의하세요.",
                icon: "check"
            });
            return;
        }

        AppContext.openAlert({
            title: "회원가입 신청",
            msg: "회원가입 신청하시겠습니까?",
            icon: "check",
            confirmText: "가입신청",
            handleConfirm: () => {
                Axios.dataAccess({
                    url: "portal/mbr/checkTelno.do",
                    methodType: "post",
                    paramType: "object",
                    paramData: {
                        telno: telno
                    },
                    onSuccessFn: (res: any) => {
                        if (res.item > 0) {
                            AppContext.openAlert({
                                title: "휴대폰 번호 중복",
                                msg: "이미 가입되어 있는 휴대폰 번호입니다.",
                                icon: "warning"
                            });
                            return;
                        }

                        const plainPswd = pswd;

                        setPswd("");
                        setPswd2("");

                        Axios.dataAccess({
                            url: "portal/mbr/genRsaKeyTempUserId.do",
                            methodType: "post",
                            paramType: "object",
                            paramData: {
                                userId: userId
                            },
                            onSuccessFn: (res: any) => {
                                const pubKey = res.item.rsaInfo.pubKeyStr;
                                const encrypt = new JSEncrypt();
                                encrypt.setPublicKey(pubKey);

                                Axios.dataAccess({
                                    url: "portal/mbr/regUserInfo.do",
                                    methodType: "post",
                                    paramType: "json",
                                    paramData: {
                                        userId: userId,
                                        userNm: userNm.trim(),
                                        encPassword: encrypt.encrypt(plainPswd),
                                        upOgnzCd: upOgnzCd,
                                        ognzCd: ognzCd,
                                        telno: telno
                                    },
                                    onSuccessFn: () => {
                                        navigate("/portal/welcome/" + userNm + "/" + userId);
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });
    }

    const checkUserId = (userId: string) => {
        const chkReg = /^[a-zA-Z0-9]{4,20}$/;
        const chkUserId = chkReg.test(userId);

        if (chkUserId) {
            Axios.dataAccess({
                url: "portal/mbr/checkUserId.do",
                methodType: "post",
                paramType: "object",
                paramData: {
                    userId: userId
                },
                onSuccessFn: (res: any) => {
                    if (res.item > 0) {
                        setUserIdChkMsg("중복된 아이디가 존재하여 사용할 수 없습니다.");
                        setUserIdChkOk(false);
                    } else {
                        setUserIdChkMsg("사용 가능한 아이디입니다.");
                        setUserIdChkOk(true);
                    }
                }
            });
        } else {
            setUserIdChkMsg("영문 또는 숫자로만 4자 이상, 20자 이하로 입력하세요.");
            setUserIdChkOk(false);
        }
    };

    const checkPassword = (password: string) => {
        if (Util.chkPasswdPtn(password)) {
            setPasswdChkMsg("");
        } else {
            setPasswdChkMsg("영문, 숫자, 특수문자를 포함한 8자 이상, 20자 이하로 입력하세요");
        }
    };

    return (
        <div
            className='w100p dpFlx flxdCol aiC pt10 pb10'
            style={{
                minHeight: "100dvh",
                backgroundColor: "#f6f7f9",
                boxSizing: "border-box",
                paddingLeft: pageSidePadding,
                paddingRight: pageSidePadding
            }}
        >
            <div
                className="bgcWhite bsOut bsBdb"
                style={{
                    width: cardWidth,
                    borderRadius: 10,
                    boxSizing: "border-box",
                    marginTop: isMobile ? 10 : 20,
                    marginBottom: isMobile ? 20 : 30,
                    overflowX: "hidden",
                    padding: isMobile ? 16 : 20
                }}
            >
                <div
                    className='w100p dpFlx aiC jcL csP'
                    onClick={() => navigate('/portal/login')}
                    style={{ paddingTop: 4 }}
                >
                    <img
                        src={Util.getImgSrc("common/logo.png")}
                        width={isMobile ? 100 : 119}
                        height={isMobile ? 34 : 41}
                        alt="logo"
                    />
                </div>

                <div
                    className='w100p dpFlx aiC jcC pt10 pb40'
                    style={{
                        paddingTop: isMobile ? 12 : 10,
                        paddingBottom: isMobile ? 24 : 32
                    }}
                >
                    <span
                        className="fcBlack ml10 fw700"
                        style={{
                            fontSize: isMobile ? 30 : 40,
                            letterSpacing: -1,
                            marginLeft: 0
                        }}
                    >
                        회원가입
                    </span>
                </div>

                <div
                    className="dpFlx flxdCol"
                    style={{
                        width: inputWidth,
                        margin: "0 auto",
                        rowGap: fieldGap
                    }}
                >
                    {/* 아이디 */}
                    <div>
                        <div
                            className="fm-c fs13 fc222222"
                            style={{ marginBottom: labelGap }}
                        >
                            아이디
                        </div>
                        <TextBox value={userId}
                            placeholder="아이디를 입력하세요" width={inputWidth}
                            height={isMobile ? 48 : 50} fontSize={13} fontFamily="fm-c"
                            color="#222" letterSpacing={-0.5 as any}
                            borderColor="#cfcfcf" borderOnColor="#222" borderRadius={8}
                            style={{ backgroundColor: "#fff", padding: "0 10px" } as any}
                            maxLength={20}
                            onChangeFunc={(text: any) => {
                                setUserId(text);
                                checkUserId(text);
                            }}
                            iconEl={
                                <img
                                    onClick={() => setUserId("")}
                                    className={'csP ' + (Util.isEmpty(userId) ? "dpNone" : "")}
                                    src={Util.getImgSrc("common/icon_cancel_fill_18.png")}
                                    alt="icon_cancel_fill_18"
                                />
                            }
                        />
                        <span
                            className={"SpoqaHanSansNeo-Regular fs13 ls065 wsPw " + (Util.isEmpty(userId) || !userIdChkOk ? "fcFF0000" : "fc17A840")}
                            style={{
                                display: "block",
                                marginTop: helperGap,
                                wordBreak: "keep-all"
                            }}
                        >
                            {userIdChkMsg}
                        </span>
                    </div>

                    {/* 이름 */}
                    <div>
                        <div
                            className="fm-c fs13 fc222222"
                            style={{ marginBottom: labelGap }}
                        >
                            이름
                        </div>
                        <TextBox value={userNm}
                            placeholder="이름을 입력하세요"
                            width={inputWidth} height={isMobile ? 48 : 50}
                            fontSize={13} fontFamily="fm-c" color="#222"
                            letterSpacing={-0.5 as any}
                            borderColor="#cfcfcf" borderOnColor="#222" borderRadius={8}
                            style={{ backgroundColor: "#fff", padding: "0 10px" } as any}
                            onChangeFunc={(text: any) => setUserNm(text)}
                            maxLength={10}
                            iconEl={
                                <img
                                    onClick={() => setUserNm("")}
                                    className={'csP ' + (Util.isEmpty(userNm) ? "dpNone" : "")}
                                    src={Util.getImgSrc("common/icon_cancel_fill_18.png")}
                                    alt="icon_cancel_fill_18"
                                />
                            }
                        />
                    </div>

                    {/* 비밀번호 */}
                    <div>
                        <div
                            className="fm-c fs13 fc222222"
                            style={{ marginBottom: labelGap }}
                        >
                            비밀번호
                        </div>
                        <TextBox type="password" value={pswd}
                            placeholder="비밀번호"
                            width={inputWidth} height={isMobile ? 48 : 50}
                            fontSize={13} fontFamily="fm-c" color="#222"
                            letterSpacing={-0.5 as any}
                            borderColor="#cfcfcf" borderOnColor="#222" borderRadius={8}
                            style={{ backgroundColor: "#fff", padding: "0 10px" } as any}
                            onChangeFunc={(text: string) => {
                                setPswd(text);
                                checkPassword(text);
                            }}
                            iconEl={
                                <img
                                    onClick={() => setPswd("")}
                                    className={'csP ' + (Util.isEmpty(pswd) ? "dpNone" : "")}
                                    src={Util.getImgSrc("common/icon_cancel_fill_18.png")}
                                    alt="icon_cancel_fill_18"
                                />
                            }
                        />
                        <span
                            className="SpoqaHanSansNeo-Regular fs13 ls065 wsPw fcFF0000"
                            style={{
                                display: "block",
                                marginTop: helperGap,
                                wordBreak: "keep-all"
                            }}
                        >
                            {passwdChkMsg}
                        </span>
                    </div>

                    {/* 비밀번호 확인 */}
                    <div>
                        <div
                            className="fm-c fs13 fc222222"
                            style={{ marginBottom: labelGap }}
                        >
                            비밀번호 확인
                        </div>
                        <TextBox type="password" value={pswd2}
                            placeholder="비밀번호 확인"
                            width={inputWidth} height={isMobile ? 48 : 50}
                            fontSize={13} fontFamily="fm-c" color="#222"
                            letterSpacing={-0.5 as any}
                            borderColor="#cfcfcf" borderOnColor="#222" borderRadius={8}
                            style={{ backgroundColor: "#fff", padding: "0 10px" } as any}
                            onChangeFunc={(text: any) => setPswd2(text)}
                            iconEl={
                                <img
                                    onClick={() => setPswd2("")}
                                    className={'csP ' + (Util.isEmpty(pswd2) ? "dpNone" : "")}
                                    src={Util.getImgSrc("common/icon_cancel_fill_18.png")}
                                    alt="icon_cancel_fill_18"
                                />
                            }
                        />
                    </div>

                    {/* 휴대폰 번호 */}
                    <div>
                        <div
                            className="fm-c fs13 fc222222"
                            style={{ marginBottom: labelGap }}
                        >
                            휴대폰 번호
                        </div>
                        <TextBox type="phone" value={Util.setPhoneNum(telno)}
                            width={inputWidth} height={isMobile ? 48 : 50}
                            fontSize={13} fontFamily="fm-c" color="#222222"
                            letterSpacing={-0.5 as any}
                            borderColor="#cfcfcf" borderOnColor="#222" borderRadius={8}
                            style={{ backgroundColor: "#fff", padding: "0 10px" } as any}
                            maxLength={30}
                            placeholder="휴대폰번호를 입력하세요."
                            onChangeFunc={(text: string) => setTelno(Util.unHypen(text))}
                            iconEl={
                                <img
                                    onClick={() => setTelno("")}
                                    className={'csP ' + (Util.isEmpty(telno) ? "dpNone" : "")}
                                    src={Util.getImgSrc("common/icon_cancel_fill_18.png")}
                                    alt="icon_cancel_fill_18"
                                />
                            }
                        />
                    </div>

                    {/* 1차 소속 */}
                    <div>
                        <div
                            className="fm-c fs13 fc222222"
                            style={{ marginBottom: labelGap }}
                        >
                            1차 소속(본부)
                        </div>
                        <SelectBox value={upOgnzCd}
                            width={inputWidth} height={isMobile ? 48 : 50}
                            optionHeight={36} fontSize={13} fontFamily="fm-c" color="#222"
                            letterSpacing={-0.5 as any}
                            borderColor="#cfcfcf" borderOnColor="#222" borderRadius={8} 
                            background="#fff" paddingRight={8}
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getUpOrgCodeArray("01"))}
                            placeholder="전체"
                            onChangeFunc={(data: string) => {
                                setUpOgnzCd(data);
                                setOgnzCd("");
                            }}
                        />
                    </div>

                    {/* 2차 소속 */}
                    <div>
                        <div
                            className="fm-c fs13 fc222222"
                            style={{ marginBottom: labelGap }}
                        >
                            2차 소속(지부)
                        </div>
                        <SelectBox value={ognzCd}
                            width={inputWidth} height={isMobile ? 48 : 50} optionHeight={36}
                            fontSize={13} fontFamily="fm-c" color="#222"
                            letterSpacing={-0.5 as any}
                            borderColor="#cfcfcf" borderOnColor="#222" borderRadius={8}
                            background="#fff" paddingRight={8}
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getDownOrgCodeArray(upOgnzCd))}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setOgnzCd(data)}
                        />
                    </div>

                    {/* 약관 동의 */}
                    <div style={{ marginTop: 4 }}>
                        <div
                            className="dpFlx aiC jcSb"
                            style={{
                                alignItems: isMobile ? "flex-start" : "center",
                                gap: 10,
                                paddingRight: 0
                            }}
                        >
                            <div
                                className="dpFlx aiC pl5"
                                style={{
                                    flex: 1,
                                    minWidth: 0
                                }}
                            >
                                <LabelCheckBox
                                    checked={agreeTerms}
                                    onChange={() => setAgreeTerms(!agreeTerms)}
                                    buttonColor='#000' labelText='이용약관 동의'
                                    borderColor='#929191' borderOnColor='#454545' color='#222222'
                                    textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                />
                            </div>
                            <span
                                className="fm-c fs14 fc555555 csP tdU tuOs2"
                                style={{
                                    flexShrink: 0,
                                    marginRight: 0,
                                    whiteSpace: "nowrap"
                                }}
                                onClick={() => { setTermsModalOpen(true); }}
                            >
                                전문보기
                            </span>
                        </div>

                        <div
                            className="dpFlx aiC jcSb"
                            style={{
                                alignItems: isMobile ? "flex-start" : "center",
                                gap: 10,
                                marginTop: 14,
                                paddingRight: 0
                            }}
                        >
                            <div
                                className="dpFlx aiC pl5"
                                style={{
                                    flex: 1,
                                    minWidth: 0
                                }}
                            >
                                <LabelCheckBox checked={agreePrivacy}
                                    onChange={() => setAgreePrivacy(!agreePrivacy)}
                                    buttonColor='#000' labelText='개인정보 수집 및 이용 동의'
                                    borderColor='#929191' borderOnColor='#454545' color='#222222'
                                    textClassName='Pretendard-SemiBold fs15 ls08 ml5'
                                />
                            </div>

                            <span
                                className="fm-c fs14 fc555555 csP tdU tuOs2"
                                style={{
                                    flexShrink: 0,
                                    marginRight: 0,
                                    whiteSpace: "nowrap"
                                }}
                                onClick={() => { setPrivacyModalOpen(true); }}
                            >
                                전문보기
                            </span>
                        </div>
                    </div>

                    {/* 가입하기 버튼 */}
                    <div style={{ marginTop: 4, marginBottom: 4 }}>
                        <Button
                            width={inputWidth} height={isMobile ? 54 : 62}
                            fontFamily="fm-b" fontSize={isMobile ? 18 : 20}
                            letterSpacing={-0.5} color="#fff"
                            backgroundColor="#28a745" borderRadius={8}
                            buttonClass="dpFlx aiC jcC" buttonName="가입하기"
                            onClickFunc={() => regUserInfo()}
                        />
                    </div>
                </div>
            </div>

            {/* 이용약관 모달 */}
            <Modal
                modalOpen={termsModalOpen}
                width={modalWidth}
                titleEl={<DialogTitleBar title={"이용약관"} />}
                onCloseFunc={() => setTermsModalOpen(false)}
            >
                <div
                    style={{
                        width: modalInnerWidth,
                        maxWidth: "100%",
                        height: modalBodyHeight,
                        maxHeight: "70vh",
                        overflow: "hidden",
                        boxSizing: "border-box"
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: modalBodyHeight - 90,
                            overflowY: "auto",
                            overflowX: "hidden",
                            boxSizing: "border-box",
                            wordBreak: "break-word"
                        }}
                    >
                        <ServicePolicy />
                    </div>

                    <div
                        className='w100p dpFlx aiC jcC pt30 gap10'
                        style={{
                            paddingTop: 20,
                            flexWrap: "wrap"
                        }}
                    >
                        <Button
                            width={isMobile ? 100 : 120} height={46}
                            fontFamily="fm-c" fontSize={15} letterSpacing={-0.5}
                            color="#333" backgroundColor="#bdc3c7" borderRadius={6}
                            buttonClass="dpFlx aiC jcC" buttonName="취소"
                            onClickFunc={() => setTermsModalOpen(false)}
                        />
                        <Button
                            width={isMobile ? 100 : 120} height={46}
                            fontFamily="fm-c" fontSize={15} letterSpacing={-0.5}
                            color="#fff" backgroundColor="#3498db" borderRadius={6}
                            buttonClass="dpFlx aiC jcC" buttonName={"동의"}
                            onClickFunc={() => {
                                setAgreeTerms(true);
                                setTermsModalOpen(false);
                            }}
                        />
                    </div>
                </div>
            </Modal>

            {/* 이용약관 모달 */}
            <Modal
                modalOpen={termsModalOpen}
                width={modalWidth}
                titleEl={<DialogTitleBar title={"이용약관"} />}
                onCloseFunc={() => setTermsModalOpen(false)}
            >
                <div
                    style={{
                        width: modalInnerWidth,
                        maxWidth: "100%",
                        height: modalMaxHeight,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        boxSizing: "border-box"
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            flex: 1,
                            minHeight: 0,
                            overflowY: "auto",
                            overflowX: "hidden",
                            boxSizing: "border-box",
                            wordBreak: "break-word",
                            WebkitOverflowScrolling: "touch",
                            paddingRight: 2
                        }}
                    >
                        <ServicePolicy />
                    </div>

                    <div
                        className='w100p dpFlx aiC jcC gap10'
                        style={{
                            paddingTop: isMobile ? 12 : 16,
                            paddingBottom: isMobile ? 4 : 6,
                            marginTop: 0,
                            flexWrap: "wrap",
                            flexShrink: 0,
                            backgroundColor: "#fff"
                        }}
                    >
                        <Button
                            width={isMobile ? 96 : 120}
                            height={isMobile ? 44 : 46}
                            fontFamily="fm-c"
                            fontSize={15}
                            letterSpacing={-0.5}
                            color="#333"
                            backgroundColor="#bdc3c7"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="취소"
                            onClickFunc={() => setTermsModalOpen(false)}
                        />
                        <Button
                            width={isMobile ? 96 : 120}
                            height={isMobile ? 44 : 46}
                            fontFamily="fm-c"
                            fontSize={15}
                            letterSpacing={-0.5}
                            color="#fff"
                            backgroundColor="#3498db"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName={"동의"}
                            onClickFunc={() => {
                                setAgreeTerms(true);
                                setTermsModalOpen(false);
                            }}
                        />
                    </div>
                </div>
            </Modal>

            {/* 개인정보처리방침 모달 */}
            <Modal
                modalOpen={privacyModalOpen}
                width={modalWidth}
                titleEl={<DialogTitleBar title={"개인정보처리방침"} />}
                onCloseFunc={() => setPrivacyModalOpen(false)}
            >
                <div
                    style={{
                        width: modalInnerWidth,
                        maxWidth: "100%",
                        height: modalMaxHeight,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        boxSizing: "border-box"
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            flex: 1,
                            minHeight: 0,
                            overflowY: "auto",
                            overflowX: "hidden",
                            boxSizing: "border-box",
                            wordBreak: "break-word",
                            WebkitOverflowScrolling: "touch",
                            paddingRight: 2
                        }}
                    >
                        <PrivacyPolicy />
                    </div>

                    <div
                        className='w100p dpFlx aiC jcC gap10'
                        style={{
                            paddingTop: isMobile ? 12 : 16,
                            paddingBottom: isMobile ? 4 : 6,
                            marginTop: 0,
                            flexWrap: "wrap",
                            flexShrink: 0,
                            backgroundColor: "#fff"
                        }}
                    >
                        <div
                            className='dpFlx aiC jcC csP'
                            style={{
                                width: isMobile ? 96 : 120,
                                height: isMobile ? 44 : 46,
                                borderRadius: 6,
                                backgroundColor: "#bdc3c7",
                                flexShrink: 0
                            }}
                            onClick={() => { setPrivacyModalOpen(false); }}
                        >
                            <span className='fm-c fs15 ls07 fc222222'>취소</span>
                        </div>

                        <div
                            className='dpFlx aiC jcC csP'
                            style={{
                                width: isMobile ? 96 : 120,
                                height: isMobile ? 44 : 46,
                                borderRadius: 6,
                                backgroundColor: "#3498db",
                                flexShrink: 0
                            }}
                            onClick={() => {
                                setAgreePrivacy(true);
                                setPrivacyModalOpen(false);
                            }}
                        >
                            <span className='fm-c fs15 ls07 fcWhite'>동의</span>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default MbrJoinAply;